import { ReactNode } from 'react';

interface FieldProps {
  label: ReactNode;
  required?: boolean;
  hint?: ReactNode;
  children: ReactNode;
}

export const Field = ({ label, required, hint, children }: FieldProps) => (
  <label className="field">
    <div className="field-label">
      {label}
      {required && <span className="required">*</span>}
    </div>
    {children}
    {hint && <div className="field-hint">{hint}</div>}
  </label>
);

export default Field;
